import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Typography,
  Row,
  Col,
  Tag,
  Empty,
  Spin,
} from 'antd';
import {
  PlusOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { noticiasAPI } from '../services/api';
import ImageUpload from '../components/ImageUpload';
import ItemCard from '../components/ItemCard';
import { getImageUrl } from '../utils/getImageUrl';

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const NoticiasPage = () => {
  const [noticias, setNoticias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingNoticia, setEditingNoticia] = useState(null);
  const [filtro, setFiltro] = useState('');
  const [form] = Form.useForm();

  useEffect(() => {
    loadNoticias();
  }, [filtro]);

  const loadNoticias = async () => {
    setLoading(true);
    try {
      const response = await noticiasAPI.getAll(filtro);
      setNoticias(response.data);
    } catch (error) {
      message.error('Erro ao carregar notícias');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingNoticia(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (noticia) => {
    setEditingNoticia(noticia);
    form.setFieldsValue(noticia);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await noticiasAPI.delete(id);
      message.success('Notícia deletada com sucesso');
      loadNoticias();
    } catch (error) {
      message.error('Erro ao deletar notícia');
      console.error(error);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editingNoticia) {
        await noticiasAPI.update(editingNoticia._id, values);
        message.success('Notícia atualizada com sucesso');
      } else {
        await noticiasAPI.create(values);
        message.success('Notícia criada com sucesso');
      }
      setModalVisible(false);
      loadNoticias();
    } catch (error) {
      message.error('Erro ao salvar notícia');
      console.error(error);
    }
  };
  const renderNoticiaImage = (noticia) => {
    return noticia.imagem ? (
      <img 
        src={getImageUrl(noticia.imagem)} 
        alt="Notícia" 
        className="card-image"
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
    ) : (
      <div className="card-image-placeholder">
        <FileTextOutlined style={{ fontSize: 24 }} />
      </div>
    );
  };

  const renderNoticiaContent = (noticia) => {
    return (
      <div className="card-text">
        {noticia.texto}
      </div>
    );
  };

  const renderNoticiaMeta = (noticia) => {
    return (
      <>
        <Tag color={noticia.produto === 'CSAP' ? 'blue' : 'green'}>
          {noticia.produto}
        </Tag>
      </>
    );
  };
  return (
    <div className="admin-page-container">      <div className="filter-section">
        <Row style={{ width: '100%' }} justify="space-between" align="middle">
          <Col>
            <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
              Nova Notícia
            </Button>
          </Col>
          <Col>
            <Select
              placeholder="Filtrar por produto"
              style={{ width: 200 }}
              value={filtro}
              onChange={setFiltro}
              allowClear
            >
              <Option value="CSAP">CSAP</Option>
              <Option value="RHA">RHA</Option>
            </Select>
          </Col>
        </Row>
      </div><Spin spinning={loading}>
        {noticias.length === 0 ? (
          <Empty 
            description="Nenhuma notícia encontrada"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        ) : (
          <div className="cards-container">
            {noticias.map(noticia => (
              <ItemCard
                key={noticia._id}
                item={noticia}
                onEdit={handleEdit}
                onDelete={handleDelete}
                renderImage={renderNoticiaImage}
                renderContent={renderNoticiaContent}
                renderMeta={renderNoticiaMeta}
                showLink={true}
              />
            ))}
          </div>
        )}
      </Spin>

      <Modal
        title={editingNoticia ? 'Editar Notícia' : 'Nova Notícia'}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => form.submit()}
        width={800}
        okText="Salvar"
        cancelText="Cancelar"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="modal-form"
        >
          <Form.Item
            name="titulo"
            label="Título"
            rules={[{ required: true, message: 'Digite o título' }]}
          >
            <Input placeholder="Título da notícia" />
          </Form.Item>

          <Form.Item
            name="produto"
            label="Produto"
            rules={[{ required: true, message: 'Selecione o produto' }]}
          >
            <Select placeholder="Selecione o produto">
              <Option value="CSAP">CSAP - Cuidados Saúde Atenção Primária</Option>
              <Option value="RHA">RHA - Reprodução Humana Assistida</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="imagem"
            label="Imagem"
            rules={[{ required: true, message: 'Faça upload da imagem' }]}
          >
            <ImageUpload />
          </Form.Item>

          <Form.Item
            name="texto"
            label="Texto"
            rules={[{ required: true, message: 'Digite o texto' }]}
          >
            <TextArea rows={4} placeholder="Texto da notícia" />
          </Form.Item>

          <Form.Item
            name="link"
            label="Link"
            rules={[
              { required: true, message: 'Digite o link' },
              { type: 'url', message: 'Digite uma URL válida' }
            ]}
          >
            <Input placeholder="https://..." />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default NoticiasPage;
